// extracted by mini-css-extract-plugin
module.exports = {"styledAccordion":"rdjWoE21"};